import createAxiosInstance from '../createAxiosInstance';

const CATEGORY_API_URL = import.meta.env.VITE_API_URL_CATEGORY;

if (CATEGORY_API_URL === undefined) {
    throw new Error('Category API URL is not defined');
}

const axios = createAxiosInstance(CATEGORY_API_URL);

export default axios;
